import Vue from "vue";
import { ToastPlugin, ModalPlugin } from "bootstrap-vue";
import VueCompositionAPI from "@vue/composition-api";
import VueLazyload from "vue-lazyload";

Vue.use(VueLazyload, {
  loading: "/loading.gif",
  attempt: 1,
});

import i18n from "@/libs/i18n";
import router from "./router";
import store from "./store";
import App from "./App.vue";

// Global Components
import "./global-components";

// 3rd party plugins
import "@axios";
import "@/libs/acl";
import "@/libs/portal-vue";
import "@/libs/clipboard";
import "@/libs/toastification";
import "@/libs/sweet-alerts";
import "@/libs/vue-select";
import "@/libs/tour";

import mixin from "./mixin";
// Axios Mock Adapter
import "@/@fake-db/db";

//vue pusher
import VuePusher from "vue-pusher";
const PUSHER_KEY = process.env.VUE_APP_PUSHER_KEY || "7d06ccaf1be0caeb2ee8";
const PUSHER_CLUSTER = process.env.VUE_APP_PUSHER_CLUSTER || "ap1";
Vue.use(VuePusher, {
  api_key: PUSHER_KEY,
  options: {
    cluster: PUSHER_CLUSTER,
    encrypted: true,
  },
});

// BSV Plugin Registration
Vue.use(ToastPlugin);
Vue.use(ModalPlugin);

// Composition API
Vue.use(VueCompositionAPI);

// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require("@core/assets/fonts/feather/iconfont.css"); // For form-wizard

// import core styles
require("@core/scss/core.scss");

// import assets styles
require("@/assets/scss/style.scss");

Vue.config.productionTip = false;
Vue.mixin(mixin);

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
